import { buildHeaders } from "./_headers.util";
import axios from "axios";
const API_URL = `${process.env.VUE_APP_API_URL}payroll-deductions/`;

export default {
  getAll(l) {
    return axios.get(API_URL, { headers: buildHeaders() });
  },
  get(id) {
    return axios.get(API_URL + id, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(API_URL + id, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(API_URL + id, { headers: buildHeaders() });
  }
};
